var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5666 0.733464C23.8759 1.04288 24.0497 1.46249 24.0497 1.90001C24.0497 2.33753 23.8759 2.75714 23.5666 3.06656L10.3666 16.2666C10.0571 16.5759 9.63754 16.7497 9.20002 16.7497C8.7625 16.7497 8.34289 16.5759 8.03347 16.2666L1.43347 9.66656C1.13291 9.35537 0.966596 8.93858 0.970355 8.50595C0.974115 8.07333 1.14764 7.65949 1.45357 7.35356C1.75949 7.04764 2.17333 6.87411 2.60596 6.87035C3.03858 6.86659 3.45537 7.0329 3.76657 7.33346L9.20002 12.7669L21.2335 0.733464C21.5429 0.424137 21.9625 0.250366 22.4 0.250366C22.8375 0.250366 23.2571 0.424137 23.5666 0.733464Z",
    fill: "#186FAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.418e1c4aede94d5ac9c64a310cce7116.svg";
export { ForwardRef as ReactComponent };